import { DefaultTheme } from "styled-components";

const defaultTheme: DefaultTheme = {
  colors: {
    black: "#393939",
    blue: "#6FCFEB",
    white: "#FFFFFF",
    pink: "#EB148D",
    darkBlue: "#041F41",
    grey: "#E8E8E8",
    nrmaBlue: "#000E82",
    nrmaMidGrey: "#75787B",
    nrmaSeaFoam: "#28F0B4",
  },
};

export default defaultTheme;
